import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import moment from 'moment';

import { getCurrencySymbol } from 'helpers/financial';
import { getTimezoneFromState } from 'helpers/intl';

import EntityStateUpdater from 'component/EntityStateUpdater';

import Loader from 'components/layout/Loader';
import Data from 'components/Data';
import Entity from 'components/Entity';

import FormInput from 'components/forms/FormInput';
import FormSwitchery from 'components/forms/FormSwitchery';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import DatePicker from 'components/forms/DatePicker';
import FormErrors from 'components/forms/FormErrors';

import { entityMetaMapping } from 'js/constants';

class BudgetForm extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      entityLoaded: false,
      entityChanged: false,
    };

    this.entity = new Entity();
    // if we get budget data from the outside, we can pass it on to our data entity
    this.entity.setData(
      props.budget || { currency: props.webApp.currency, period: 'week', date_from: moment().toISOString() }
    );

    if (props.meta[entityMetaMapping.budget] !== undefined && !props.meta[entityMetaMapping.budget].pending) {
      this.entity.setMeta(props.meta, entityMetaMapping.budget);

      this.state = {
        ...this.state,
        entityLoaded: true,
        entity: this.entity,
      };
    }
  }

  componentDidUpdate = () => {
    const { meta } = this.props;

    if (
      meta[entityMetaMapping.budget] !== undefined &&
      !meta[entityMetaMapping.budget].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, entityMetaMapping.budget);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }
  };

  formSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState(
      prevState => ({ entity: prevState.entity.validate() }),
      () => {
        if (this.state.entity.isValid) {
          this.props.onSubmit(this.state.entity.processedData);
        }
      }
    );
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      webApp,
      defaultTimezone,
      formStatus,
    } = this.props;
    const { entity, entityLoaded } = this.state;

    const currencySymbol = getCurrencySymbol((entityLoaded && entity.getCurrency()) || webApp.currency);

    const periodOptions = [
      { value: 'week', label: messages.week },
      { value: 'month', label: messages.month },
      { value: 'quarter', label: messages.quarter },
    ];

    const minDate = moment();

    return (
      <Row>
        <Data dataName="budget" /> {/* fetch meta data */}
        <Col xs={12}>
          <FormErrors formStatus={formStatus} />

          {entityLoaded ? (
            <form method="post" onSubmit={this.formSubmit}>
              <div class="panel panel-transparent">
                <div class="form-group-attached">
                  <FormInput
                    prefixAddon={currencySymbol}
                    name="value"
                    label={messages.budget_value}
                    value={entity.getValue()}
                    meta={entity.getValueMetaInformation()}
                    validation={entity.getValueValidationResult()}
                    onChange={this.updateEntity}
                    disabled={formStatus.pending}
                    type="number"
                  />
                  <div class="form-group form-group-default padding-10">
                    <FormSwitchery
                      name="isRecurring"
                      label={messages.recurring}
                      checked={entity.getIsRecurring()}
                      value
                      onChange={this.updateEntity}
                      disabled={formStatus.pending}
                    />
                  </div>
                  {entity.getIsRecurring() && (
                    <FormAutocomplete
                      name="period"
                      label={messages.period}
                      options={periodOptions}
                      value={entity.getPeriod()}
                      onChange={this.updateEntity}
                      disabled={formStatus.pending}
                    />
                  )}
                  <Row>
                    <Col xs={6}>
                      <DatePicker
                        name="dateFrom"
                        label={messages.date_from}
                        value={entity.getDateFrom()}
                        minDate={minDate}
                        locale={appIntl.locale}
                        displayTz={defaultTimezone}
                        onChange={this.updateEntity}
                        disabled={formStatus.pending}
                      />
                    </Col>
                    <Col xs={6}>
                      <DatePicker
                        name="dateTo"
                        label={messages.date_to}
                        value={entity.getDateTo()}
                        minDate={minDate}
                        locale={appIntl.locale}
                        displayTz={defaultTimezone}
                        onChange={this.updateEntity}
                        showClearDate
                        placeholder={messages.without_end_date}
                        disabled={formStatus.pending}
                      />
                    </Col>
                  </Row>
                </div>

                <div class="text-right m-t-15">
                  <Button
                    bsSize="lg"
                    disabled={formStatus.pending}
                    type="submit"
                    bsStyle={this.state.entityChanged ? 'primary' : 'default'}
                  >
                    <i class={'fa-fw ' + (formStatus.pending ? ' fa fa-circle-notch fa-spin' : 'fal fa-save')} />{' '}
                    {messages.save}
                  </Button>
                </div>
              </div>
            </form>
          ) : (
            <Loader />
          )}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    webApp: state.webApp,
    appIntl: state.intl,
    meta: state.entityMeta,
    defaultTimezone: getTimezoneFromState(state),
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(BudgetForm)));
